import { useEffect } from "react";
import { useNavigate } from "react-router";
import Preloader from "./preloader";

const HomeRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, [navigate]);

  return <Preloader />;
};

export default HomeRedirect;
